import React, { useState, useRef, useEffect } from 'react';
import {FormularioNombre} from './FormularioNombre';
import { BotonGuardar } from './BotonGuardar';

export const Prueba = () => {
    const [errores, setErrores] = useState({});
    const [usuario, setUsuarios] = useState({});

   

    return (
    <div>
       <h1>Prueba</h1>
        <FormularioNombre errores={errores } usuario = {usuario} setUsuarios ={setUsuarios}></FormularioNombre>
        <BotonGuardar errores={errores } usuario = {usuario} setUsuarios ={setUsuarios}></BotonGuardar>
        </div>
    )
}